module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/3v5SB9/tc-custom/9781504020961.jpg?1702083390820",
      "alt": "This image is the cover for the book Midnight Moropus"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Midnight Moropus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Can Jon find a ghostly horse that’s been extinct for centuries?")]), _c('br'), _c('br'), _vm._v(" Jon is a lonely orphan who lives on a farm with his adopted parents. When they ask what he’d like for his birthday, Jon knows immediately: to see the Moropus, a prehistoric horse that’s big and furry, with claws on its feet instead of hooves. According to legend, it haunts the lonely moors at a waterfall that is known as Horse Force because its gushing cascade sound just like a mare’s whinny."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But there’s 1 problem: If Jon wants to see the ghost of the legendary creature, he has to visit Horse Force at the stroke of midnight—alone. Can he get up the courage to go there all by himself in the dead of night? Luckily there is 1 friend who can help Jon—his faithful pony Whiskers!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This ebook features illustrations by Gavin Rowe and a personal history of Joan Aiken including rare images from the author’s estate."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joan Aiken, Gavin Rowe\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("&lt;P&gt;Joan Aiken, daughter of the American writer Conrad Aiken, was born in Rye, Sussex, England, and has written more than sixty books for children, including &lt;I&gt;The Wolves of Willoughby Chase&lt;/I&gt;.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0